import { useCallback, useState } from "react";
import { stripe as api } from "@/lib/api/stripe";
import type { CheckoutSessionInput } from "@/lib/api/stripe";

export function useStripeCheckout() {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  const start = useCallback(async (input: CheckoutSessionInput) => {
    setBusy(true);
    setError(null);
    try {
      const { url } = await api.createCheckoutSession(input);
      window.location.assign(url);
    } catch (e) {
      setError(e as Error);
      throw e;
    } finally {
      setBusy(false);
    }
  }, []);

  return { busy, error, start };
}
